(() => {
  if (window.WENNEBIRD_AMAZON_RECOVERY_LOADED) return;
  window.WENNEBIRD_AMAZON_RECOVERY_LOADED = true;
  const states = new Map();
  const providerError = 'There was an error rendering this component';
  const providerModule = 'mocca.tuxedo.prod.barossa.dubai.aws.dev/assets/scripts/client-entry.js';

  function selected(state) {
    const root = state.root;
    if (!root.isConnected || !state.element?.isConnected || !state.block.contains(state.element) ||
      root.dataset.wbDeliveryStatus !== 'us_stock' || root.dataset.wbFitmentInvalid !== 'false' ||
      root.dataset.wbVariantPending === 'true' || root.dataset.wbVariantError === 'true') return false;
    const input = root.querySelector('.product-variant-id');
    if (!input || input.disabled || input.value !== state.element?.getAttribute('skuid')) return false;
    let variants = [];
    try { variants = JSON.parse(root.querySelector('[data-wb-product-variants]')?.textContent || '[]'); } catch {}
    const variant = variants.find((entry) => String(entry.id) === input.value);
    if (!variant || !variant.sku || variant.sku !== state.element.getAttribute('skuvalue')) return false;
    const quantity = root.querySelector('.quantity__input');
    return Number(state.element.getAttribute('quantity')) === Number(quantity?.value || 1);
  }

  function show(state, loading) {
    state.panel.hidden = !selected(state);
    state.button.disabled = loading || state.panel.hidden;
    state.panel.setAttribute('aria-busy', String(loading));
    state.message.textContent = loading ? state.message.dataset.loadingText : state.message.dataset.errorText;
    if (state.reload) {
      state.reload.hidden = loading || !state.manualAttempts || state.panel.hidden;
      if (!state.reload.hidden) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', state.root.querySelector('.product-variant-id').value);
        state.reload.href = url.toString();
      }
    }
  }

  function stopTimer(state) {
    clearTimeout(state.timer);
    clearTimeout(state.probeTimer);
    state.timer = null;
    state.probeTimer = null;
  }

  function retry(state, manual = false) {
    if (state.loading || !selected(state) || !customElements.get('delivery-promise-container')) return;
    stopTimer(state);
    if (manual) state.manualAttempts++;
    state.autoTried = true;
    state.loading = true;
    state.failed = false;
    state.awaitingFreshMarkup = true;

    const element = state.element;
    const parent = element?.parentNode;
    if (!element || !parent) return;

    const replacement = element.cloneNode(true);
    state.observer?.disconnect();
    parent.replaceChild(replacement, element);
    state.element = replacement;

    state.observer = new MutationObserver((records) => {
      if (records.some((record) => record.type === 'childList')) state.awaitingFreshMarkup = false;
      inspect(state);
    });
    state.observer.observe(replacement, { attributes: true, attributeFilter: ['skuid', 'skuvalue', 'quantity'] });
    if (replacement.shadowRoot) {
      state.observer.observe(replacement.shadowRoot, { childList: true, subtree: true });
      if (replacement.shadowRoot.childNodes.length) state.awaitingFreshMarkup = false;
    }

    show(state, true);

    let probes = 0;
    const probe = () => {
      if (!state.loading || !selected(state) || !state.element?.isConnected) return;
      if (state.element.shadowRoot) {
        try {
          state.observer?.observe(state.element.shadowRoot, { childList: true, subtree: true });
        } catch {}
        if (state.element.shadowRoot.childNodes.length) state.awaitingFreshMarkup = false;
      }
      inspect(state);
      probes += 1;
      if (state.loading && probes < 40) state.probeTimer = setTimeout(probe, 250);
    };
    state.probeTimer = setTimeout(probe, 100);

    state.timer = setTimeout(() => {
      state.loading = false;
      state.failed = true;
      show(state, false);
    }, 15000);
  }

  function inspect(state) {
    if (!state.root.isConnected) return;
    if (!selected(state)) {
      state.panel.hidden = true;
      state.button.disabled = true;
      return;
    }
    if (state.loading && state.awaitingFreshMarkup) {
      show(state, true);
      return;
    }
    const markup = state.element.shadowRoot?.innerHTML || '';
    if (markup.includes(providerError)) {
      state.failed = true;
      if (state.loading) {
        state.loading = false;
        stopTimer(state);
      }
      show(state, false);
      if (!state.autoTried) {
        state.autoTried = true;
        state.timer = setTimeout(() => retry(state), 1200);
      }
      return;
    }
    if (state.element.shadowRoot?.querySelector('#ddp-zipcode-label, #ddp-zipcode-label-no-expiry, #ddp-date, [data-testid="test-ddp-zipcode-label"]')) {
      state.failed = false;
      state.loading = false;
      stopTimer(state);
      state.panel.hidden = true;
      state.button.disabled = false;
      state.panel.setAttribute('aria-busy', 'false');
      return;
    }
    if (state.failed || state.loading) show(state, state.loading);
  }

  function observe(state) {
    const element = state.block.querySelector('delivery-promise-container');
    if (!element) {
      state.observer?.disconnect();
      stopTimer(state);
      state.element = null;
      state.loading = false;
      state.panel.hidden = true;
      state.button.disabled = true;
      return;
    }
    if (state.element !== element) {
      state.observer?.disconnect();
      stopTimer(state);
      state.loading = false;
      state.awaitingFreshMarkup = false;
      state.element = element;
      state.observer = new MutationObserver((records) => {
        if (records.some((record) => record.type === 'childList')) state.awaitingFreshMarkup = false;
        inspect(state);
      });
      state.observer.observe(element, { attributes: true, attributeFilter: ['skuid', 'skuvalue', 'quantity'] });
      if (element.shadowRoot) state.observer.observe(element.shadowRoot, { childList: true, subtree: true });
    } else if (element.shadowRoot) {
      state.observer.observe(element.shadowRoot, { childList: true, subtree: true });
    }
    inspect(state);
  }

  function scan() {
    for (const [block, state] of states) {
      if (!block.isConnected) {
        state.observer?.disconnect();
        stopTimer(state);
        states.delete(block);
      }
    }
    document.querySelectorAll('product-info [data-wb-prime-promise]').forEach((block) => {
      if (!states.has(block)) {
        const panel = block.querySelector('[data-wb-delivery-recovery]');
        const button = panel?.querySelector('[data-wb-delivery-retry]');
        const message = panel?.querySelector('[data-wb-delivery-recovery-message]');
        if (!panel || !button || !message) return;
        const state = { block, panel, button, message, reload: panel.querySelector('[data-wb-delivery-reload]'), root: block.closest('product-info'), autoTried: false, manualAttempts: 0, loading: false, failed: false };
        states.set(block, state);
        button.addEventListener('click', () => retry(state, true));
        state.reload?.addEventListener('click', (event) => {
          event.preventDefault();
          if (state.reload.hidden || !selected(state)) return;
          const url = new URL(window.location.href);
          url.searchParams.set('variant', state.root.querySelector('.product-variant-id').value);
          if (url.toString() === window.location.href) window.location.reload();
          else window.location.assign(url.toString());
        });
        customElements.whenDefined('delivery-promise-container').then(() => { if (block.isConnected) observe(state); });
      }
      observe(states.get(block));
    });
  }

  document.addEventListener('wb:variant-start', () => { for (const state of states.values()) inspect(state); });
  for (const event of ['wb:variant-ready', 'wb:delivery-status-updated', 'wb:quantity-rules-updated']) {
    document.addEventListener(event, () => { for (const state of states.values()) inspect(state); });
  }
  window.addEventListener('unhandledrejection', (event) => {
    if (!String(event.reason?.message || event.reason || '').includes(providerModule)) return;
    for (const state of states.values()) {
      if (!selected(state)) continue;
      state.failed = true;
      show(state, state.loading);
      if (!state.autoTried) {
        state.autoTried = true;
        stopTimer(state);
        state.timer = setTimeout(() => retry(state), 1200);
      }
    }
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
  else scan();
  document.addEventListener('shopify:section:load', scan);
  new MutationObserver((records) => {
    if (records.some((record) => Array.from(record.addedNodes).some((node) => node.nodeType === 1 &&
      (node.matches?.('product-info, delivery-promise-container') || node.querySelector?.('product-info, delivery-promise-container')))) ||
      Array.from(states.entries()).some(([block, state]) => !block.isConnected || state.element && !block.contains(state.element))) scan();
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
